var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 12.7537L16.2115 12.5137C16.0186 11.9529 15.3862 11.3681 14.8052 11.2141L12.655 10.6397C12.0719 10.4846 11.2401 10.6932 10.8135 11.1103L10.0353 11.8712C7.20711 11.124 4.98938 8.95547 4.2262 6.19068L5.00444 5.42973C5.43107 5.01258 5.64435 4.20036 5.48571 3.63021L4.89938 1.52673C4.74074 0.957618 4.14155 0.339275 3.56917 0.152702L3.32372 0.0720092C2.75025 -0.114564 1.93239 0.0741221 1.5058 0.491236L0.341713 1.63049C0.133749 1.83276 0.000835284 2.4113 0.000835284 2.41341C-0.0398793 6.02715 1.40931 9.50881 4.02362 12.0651C6.63151 14.615 10.179 16.0299 13.8641 15.9995C13.8834 15.9995 14.4922 15.8716 14.7002 15.6693L15.8643 14.5311C16.2908 14.114 16.4838 13.3144 16.293 12.7537Z",
    fill: "#292F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.a142e71c577ec55a884beebdaab84da8.svg";
export { ForwardRef as ReactComponent };